<div class="root-container">
  <div class="content">
    <div class="section">
      <form [formGroup]="form" >
        <div class="form-container">
          <div class="title">Please Update your password to continue</div>
          <label><input type="password" placeholder="Current password" formControlName="old_password" maxlength="20"/></label>
          <label class="password-label">
              <input [type]="show_password?'text':'password'"
                     placeholder="New password"
                     formControlName="new_password"
                     maxlength="20"/>
              <password-toggle (click)="show_password =! show_password"/>
          </label>
          <label class="password-label">
              <input [type]="show_password_confirm? 'text':'password' "
                     placeholder="Confirm New password"
                     formControlName="confirm_password"
                     maxlength="20"/>
              <password-toggle (click)="show_password_confirm =! show_password_confirm "/>
          </label>
          @if(error){
            <div class="error-message">{{ error }}</div>
          }
          <div class="checklist">
            <div [ngClass]="{'passed': regex_length.test(getNewPassword()) }">Between 8-20 Characters</div>
            <div [ngClass]="{'passed': regex_capital.test(getNewPassword()) }">At least 1 Uppercase Letter</div>
            <div [ngClass]="{'passed': regex_number.test(getNewPassword()) }">At least 1 Number</div>
            <div [ngClass]="{'passed': regex_special.test(getNewPassword()) }">At least 1 Special Character !&#64;#$%^&*()-=+_() </div>
            <div [ngClass]="{'passed': passwordMatch() }"> Passwords must match </div>
          </div>
          @if(!loading){
            <button-component [disabled]="!isComplete()"
                              (click)="save()"
                              text="Save"
                              type="primary"
                              [width]="200"/>
              <a routerLink="/logout" class="my-2 text-decoration-none">Logout</a>
          } @else {
            <div><spinner [size]="30"/> Saving </div>
          }
        </div>
      </form>
    </div>
    <div class="section">
      <img class="hero-image" src="assets/images/auth/man-security.jpg" alt="security">
    </div>
  </div>
</div>
